"use client"

import * as React from "react"
import { Button } from "@/components/ui/button"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  React.useEffect(() => {
    console.error("Client boundary caught error:", error)
  }, [error])

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center p-6 text-center">
      <div className="rounded-2xl border border-border bg-card p-8 shadow-sm max-w-md w-full">
        <h2 className="text-lg font-bold text-foreground mb-2">Algo no cargó correctamente</h2>
        <p className="text-xs text-muted-foreground mb-6">
          {error?.message || "Ocurrió un error inesperado al renderizar este componente."}
        </p>
        <Button onClick={() => reset()} variant="outline" className="rounded-xl font-semibold w-full">
          Reintentar Carga
        </Button>
      </div>
    </div>
  )
}
